// **** External Utilities ****
import { REACT_APP_ENABLE_PUSH_NOTIFICATION } from '../../../../constants/envConstants';
import { Notifications } from '../../../../constants/notification.constant';
import { URL_CONSTANTS } from '../../../../constants/urlConstants';
import apiService from '../../../../services/api.service';

export const saveUserDevices = async (
  userId,
  clientId,
  deviceType,
  deviceName,
  firebaseToken,
  enabledNotification = {}
) => {
  try {
    const payload = {
      userId,
      clientId,
      deviceType,
      deviceName,
      firebaseToken,
      enabledNotification,
    };
    const response = await apiService.postWithDiffBaseUrl(
      `/user-device`,
      payload,
      URL_CONSTANTS.NOTIFICATION.baseUrl
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const savePushNotification = async (
  userId,
  clientId,
  type,
  projectId,
  notificationId
) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const payload = { userId, clientId, projectId, type, notificationId };
      const response = await apiService.postWithDiffBaseUrl(
        `/notification/publish`,
        payload,
        URL_CONSTANTS.NOTIFICATION.baseUrl
      );
      return response?.data;
    } catch (error) {
      console.error(`Notification send error: ${error}`);
      return {};
    }
  }
};

export const getNotificationCount = async (
  userId,
  type,
  clientId,
  sub_type
) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const payload = {
        userId,
        type,
        clientId,
        sub_type: sub_type?.length > 0 ? sub_type : [0],
      };
      const response = await apiService.postWithDiffBaseUrl(
        `/notification/count`,
        payload,
        URL_CONSTANTS.NOTIFICATION.baseUrl
      );
      return response;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }
};

export const getNotification = async (
  userId,
  type,
  clientId,
  page,
  limit,
  sub_type
) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const payload = {
        page,
        limit,
        userId,
        type,
        clientId,
        sub_type: sub_type?.length > 0 ? sub_type : [0],
      };
      const response = await apiService.postWithDiffBaseUrl(
        `/notification/list`,
        payload,
        URL_CONSTANTS.NOTIFICATION.baseUrl,
        ''
      );
      return response?.notifications;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

export const updateNotificationViewed = async (
  note_id,
  type,
  user_id,
  viewed,
  reviewed,
  sub_type
) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const payload = {
        note_id,
        type,
        user_id,
        viewed,
        reviewed,
        sub_type,
        clientId: localStorage.getItem('client_id'),
      };
      await apiService.postWithDiffBaseUrl(
        `/notification/view`,
        payload,
        URL_CONSTANTS.NOTIFICATION.baseUrl
      );
    } catch (error) {
      console.error(error);
    }
  }
};

export const getSMSNotifications = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const smsDetailsRequest = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.SMS,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const smsDetailCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.SMS,
        localStorage.getItem('client_id'),
        subType
      );
      const newNotificationList = [];
      if (Array.isArray(smsDetailsRequest)) {
        if (smsDetailsRequest) {
          newNotificationList.push(...smsDetailsRequest);
        }
      }
      return {
        data: newNotificationList,
        count: Number(smsDetailCount.count ?? 0),
      };
    } catch (error) {
      console.error(error);
      return { data: [], count: 0 };
    }
  }
};

export const getEmailNotifications = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const response = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.EMAIL,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const emailCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.EMAIL,
        localStorage.getItem('client_id'),
        subType
      );
      const newEmailList = [];
      if (Array.isArray(response)) {
        if (response) {
          newEmailList.push(...response);
        }
      }
      return { emailList: newEmailList, count: Number(emailCount.count ?? 0) };
    } catch (error) {
      console.error(error);
      return { emailList: [], count: 0 };
    }
  }
};
export const getStoreNotifications = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const response = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.STORE,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const storeNotificationCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.STORE,
        localStorage.getItem('client_id'),
        subType
      );
      const newStoreList = [];
      if (Array.isArray(response)) {
        if (response) {
          newStoreList.push(...response);
        }
      }
      return {
        storeList: newStoreList,
        count: Number(storeNotificationCount.count ?? 0),
      };
    } catch (error) {
      console.error(error);
      return { storeList: [], count: 0 };
    }
  }
};

export const getInstallerNotifications = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const response = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.INSTALLER,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const installerNotificationCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.INSTALLER,
        localStorage.getItem('client_id'),
        subType
      );
      const newInstallerList = [];
      if (Array.isArray(response)) {
        if (response) {
          newInstallerList.push(...response);
        }
      }
      return {
        installerList: newInstallerList,
        count: Number(installerNotificationCount.count ?? 0),
      };
    } catch (error) {
      console.error(error);
      return { installerList: [], count: 0 };
    }
  }
};

export const getCRMNotes = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const response = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.CUSTOMER,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const crmNotesCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.CUSTOMER,
        localStorage.getItem('client_id'),
        subType
      );
      const crmNoteList = [];
      if (Array.isArray(response)) {
        if (response) {
          crmNoteList.push(...response);
        }
      }
      return {
        data: crmNoteList,
        count: Number(crmNotesCount?.count ?? 0),
      };
    } catch (error) {
      console.error(error);
      return { data: [], count: 0 };
    }
  }
};

export const getCustomerNotification = async (offset, limit, subType) => {
  if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
    try {
      const response = await getNotification(
        localStorage.getItem('user_id'),
        Notifications.CUSTOMER,
        localStorage.getItem('client_id'),
        offset,
        limit,
        subType
      );
      const customerNotesCount = await getNotificationCount(
        localStorage.getItem('user_id'),
        Notifications.CUSTOMER,
        localStorage.getItem('client_id'),
        subType
      );
      const newCustomerNotesList = [];
      if (Array.isArray(response)) {
        if (response) {
          newCustomerNotesList.push(...response);
        }
      }
      return {
        customerComms: newCustomerNotesList,
        count: Number(customerNotesCount.count ?? 0),
      };
    } catch (error) {
      console.error(error);
      return { customerComms: [], count: 0 };
    }
  }
};

export const getUserDeviceSettings = async (userId, clientId) => {
  try {
    const payload = { userId, clientId };
    const response = await apiService.getWithDiffBaseUrl(
      `/user-devices-settings`,
      payload,
      URL_CONSTANTS.NOTIFICATION.baseUrl
    );
    return response.response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const saveUserDeviceSettings = async (
  userId,
  clientId,
  deviceType,
  enabledNotification
) => {
  try {
    const payload = { userId, clientId, deviceType, enabledNotification };
    const response = await apiService.postWithDiffBaseUrl(
      `/user-devices-settings`,
      payload,
      URL_CONSTANTS.NOTIFICATION.baseUrl,
      ''
    );
    return response.device;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const syncNotifications = async () => {
  try {
    await apiService.post(
      `/auth/user/manage/syncnotifications/${localStorage.getItem('user_id')}`
    );
  } catch (error) {
    console.error(`Sync notifications error: ${error}`);
  }
};

export const crmNotesReviewRead = async (customerId, customerNoteId, type) => {
  try {
    let isReviewed = 0;
    let isViewed = 0;
    if (type === 'read') {
      isViewed = 1;
    } else if (type === 'review') {
      isReviewed = 1;
    }
    const payload = {
      customerNoteId: customerNoteId,
      customerId: customerId,
      isReveiew: isReviewed,
      isViewed: isViewed,
    };

    await apiService.putWithDiffBaseUrl(
      '/api/communication/note-status',
      payload,
      URL_CONSTANTS.CRM.baseUrl
    );
  } catch (error) {
    console.error(`Sync notifications error: ${error}`);
  }
};

export const crmEmailReviewRead = async (conversationId, type) => {
  try {
    let isReviewed = 0;
    let isViewed = 0;
    if (type === 'read') {
      isViewed = 1;
    } else if (type === 'review') {
      isReviewed = 1;
    }
    const payload = {
      conversationId: conversationId,
      isReveiew: isReviewed,
      isViewed: isViewed,
    };

    await apiService.putWithDiffBaseUrl(
      '/api/communication/email-status',
      payload,
      URL_CONSTANTS.CRM.baseUrl
    );
  } catch (error) {
    console.error(`Sync notifications error: ${error}`);
  }
};

export const crmSMSReviewRead = async (smsLogId, type) => {
  try {
    let isReviewed = 0;
    let isViewed = 0;
    if (type === 'read') {
      isViewed = 1;
    } else if (type === 'review') {
      isReviewed = 1;
    }
    const payload = {
      smsLogId: smsLogId,
      isReveiew: isReviewed,
      isViewed: isViewed,
    };

    await apiService.putWithDiffBaseUrl(
      '/api/communication/sms-status',
      payload,
      URL_CONSTANTS.CRM.baseUrl
    );
  } catch (error) {
    console.error(`Sync notifications error: ${error}`);
  }
};
